import { Menu as AntMenu } from 'antd';
import styled from 'styled-components';
export const Menu = styled(AntMenu) `
  border-right: 0;
  background-color: inherit;
  color: var(--color-text-menu);
  font-size: var(--font-size-m);
  transition: width 0.3s cubic-bezier(0.2, 0, 0, 1) 0s;

  /*** Inline ***/

  /* Selected item */
  &:not(.ant-menu-horizontal) .ant-menu-item-selected {
    background-color: inherit;
    color: var(--color-text-menu-selected);
  }

  .ant-dropdown-menu-item {
    white-space: nowrap;

    &:not(:hover) {
      background-color: inherit;
    }
  }

  /* Bottom line */
  &.ant-menu-inline .ant-menu-item:after {
    border: 0;
    content: '›';
    font-size: 34px;
    font-weight: 300;
    color: var(--color-text-selected);
    top: -4px;
    margin-left: -2px;
  }

  .ant-menu-item {
    transition: none;
  }

  .ant-menu-item:hover {
    color: var(--color-text-menu);
    transform: scaleY(1);
  }

  .ant-menu-item:active {
    background-color: transparent;
  }

  .ant-menu-item:hover:after {
    opacity: 1;
    transform: scaleY(1);
  }

  &.ant-menu-inline > .ant-menu-item a {
    color: var(--color-text-menu);
  }

  &.ant-menu-inline > .ant-menu-item-selected a {
    color: var(--color-text-menu-selected);
  }

  &.ant-menu-inline > .ant-menu-item.an {
    height: 48px;
    line-height: 48px;
    margin: 0;
    border-bottom: 1px solid var(--color-border-main);
  }

  /*** Horizontal ***/
  &.ant-menu-horizontal > .ant-menu-item a {
    color: var(--color-text-menu);
  }

  &.ant-menu-horizontal,
  &.ant-menu-horizontal > .ant-menu-item {
    border-bottom: 1px solid var(--color-text-menu);
  }

  &.ant-menu-horizontal > .ant-menu-item:after {
    display: none;
  }

  &.ant-menu-horizontal > .ant-menu-item-selected,
  &.ant-menu-horizontal > .ant-menu-item-selected a {
    color: var(--color-text-main);
    border-bottom: 1px solid var(--color-text-main);
  }

  &.ant-menu-horizontal .ant-menu-item:hover,
  &.ant-menu-horizontal .ant-menu-item:hover a {
    color: var(--color-text-menu-hover);
    border-bottom: 1px solid var(--color-text-menu);
  }

  &.ant-menu-horizontal > .ant-menu-submenu-active.ant-menu-submenu,
  &.ant-menu-horizontal > .ant-menu-submenu-active.ant-menu-submenu:hover {
    color: var(--color-text-menu-hover);
    border-color: var(--color-text-menu);
  }

  /*** Vertical ***/
  &.ant-menu-vertical .ant-menu-item {
    font-size: var(--font-size-s);
  }

  &.ant-menu-vertical .ant-menu-item:hover {
    background-color: var(--color-bg-hover);
    color: var(--color-text-menu-hover);
  }

  &.ant-menu-vertical .ant-menu-item:hover:after {
    display: none;
  }

  .ant-menu-title-content,
  .ant-menu-title-content a,
  &.ant-menu-inline.ant-menu-root .ant-menu-item,
  &.ant-menu-inline.ant-menu-root .ant-menu-submenu-title {
    transition: none;
  }
`;
Menu.SubMenu = styled(AntMenu.SubMenu) `
  .ant-menu {
    background-color: inherit;
    color: var(--color-text-menu);
  }
`;
